export const API_ENDPOINTS = {
    AUDIT_LOG: {
        SEARCH: "AuditLog/Search", 
        CONFIG: "AuditLog/GetConfig",
        DISTINCT_ENTITIES: "AuditLog/GetDistinctEntities",
        EXPORT: "AuditLog/Export",
    },
};

export const QUERY_KEYS = {
    AUDIT_LOG: {
        SEARCH: ["AuditLogSearch"],
        CONFIG: ["AuditLogConfig"],
        DISTINCT_ENTITIES: ["AuditLogDistinctEntities"],
    },
};
